<template>
  <b-modal
    hide-footer
    id="modal-cancel-secretary"
    ref="modal-cancel-secretary"
    size="xl"
    title="ถอนสิทธิ์การเป็นเลขา"
  >
    <div class="container">
      <b-overlay :show="showOverlay" rounded="sm">
        <b-card>
          <b-row>
            
            <b-col cols="12">
                <SearchFilter
                  :mode="'CancelSecretary'"
                  :autoSearch="true"
                  @handleCancelSubmit="searchFilterSubmit"
                />
              </b-col>

            <!-- Table -->
            <b-col cols="12">
              <CommonTable
                @handleOverlay="setOverlay"
                ref="tableCommon"
              >
              </CommonTable>
            </b-col>

          </b-row>
        </b-card>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BOverlay,
  BCard,
} from "bootstrap-vue";

import VueSelect from "vue-select";
import CommonTable from "./commonTableSecretaryModal";
import * as departmentRoleStore from "@/store/api/role/departmentRole.js";
import SearchFilter from "./SearchFilter";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
    BOverlay,
    VueSelect,
    CommonTable,
    SearchFilter,
  },
  props: {},
  data() {
    return {
      showOverlay: false,

      level: null,
      userDepartmentRoleId: null,
      createBy: null,
      secretaryNameList: [],

      page: 1,
      takeItems: 10,
    };
  },
  mounted() {},
  methods: {
    onShow(user, level) {
      const _this = this

      console.log(
        "onShow",
        user.userDepartmentRoleId,
        user.userId,
        user.roleId,
        level,
      );

      this.level = level;
      this.userDepartmentRoleId = user.userDepartmentRoleId;
      this.createBy = user.userId;
      this.secretaryNameList = user.secretaryNameList;

    },
    searchFilterSubmit() {
      const params = {
        userDepartmentRoleId: this.userDepartmentRoleId,
        page: 1,
        takeItems: 10
      }
      this.$refs.tableCommon.onSearchSubmit(params);
    },
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    onCancel() {
      this.$refs["modal-cancel-secretary"].hide();
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style></style>